import { updateRemoteProject } from '@/firebase/RemoteProject';
import Language from './Language';

export default interface Project {
  firestoreId?: string;
  appId: string;
  mainLanguage?: Language;
  languages: Language[];
}

export const deleteProjectLanguage = (
  project: Project,
  deletedLanguage: Language,
): Project => {
  const updatedLanguages = project.languages.filter(
    (language) => language.code !== deletedLanguage.code,
  );
  const updatedProject: Project = {
    ...project,
    languages: updatedLanguages,
  };
  updateRemoteProject(updatedProject, ['languages']);

  return updatedProject;
};

export const updateProjectMainLanguage = (
  project: Project,
  mainLanguage: Language,
): Project => {
  const updatedLanguages = project.languages.map((language) => {
    if (language.code === project.mainLanguage?.code) {
      return { ...language, isMain: false };
    }
    if (language.code === mainLanguage.code) {
      return { ...mainLanguage, isMain: true };
    }
    return language;
  });

  const updatedProject: Project = {
    ...project,
    mainLanguage: mainLanguage,
    languages: [...updatedLanguages],
  };
  updateRemoteProject(updatedProject, ['mainLanguage', 'languages']);

  return updatedProject;
};

export const addLanguageToProject = (
  project: Project,
  language: Language,
): Project => {
  const updatedProject: Project = {
    ...project,
    languages: [...project.languages, language],
  };

  updateRemoteProject(updatedProject, ['languages']);

  return updatedProject;
};
